import styled from 'styled-components';
import { Pagination, Select } from 'antd';

export const PaginationWrapper = styled(Pagination)`
	.ant-pagination-item-link {
		border: none;
		font-size: 1rem;
		background-color: transparent;
	}

	.ant-pagination-prev {
		margin-right: 0.25rem;
	}

	.ant-pagination-item-before-jump-next,
	.ant-pagination-jump-next {
		margin-right: 0 !important;
	}

	.ant-pagination-item {
		border: none;
		font-weight: 600;
		border-radius: 5px;
		margin-right: 0.25rem;
		background: #f0f0f0;

		a {
			color: #bfbfbf;
		}
	}

	.ant-pagination-item-active a {
		color: #2f54eb;
	}

	.ant-pagination-item-active {
		background-color: #eaeefd;
	}
`;

export const SelectWrapper = styled(Select)`
	margin-left: 1rem;

	.ant-select-selector {
		border: none !important;
		border-radius: 5px !important;
	}

	.ant-select-arrow {
		width: 10px;
		color: #262626;
	}
`;
